module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 人才库申报")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "error"
    }
  }, [_vm._v("\n      1.请先登陆个人会员帐号或注册（注意只对个人会员，单位会员无法报名）"), _c('br'), _vm._v("\n      2.请您确保在整个申报流程中，您所填写的信息属实。"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_center"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "200px"
    }
  }, [_c('div', {
    staticClass: "apply_info_title"
  }, [_vm._v("申报信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市县",
      "prop": "areas"
    }
  }, [_c('el-cascader', {
    staticClass: "inputSizeClass",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    model: {
      value: (_vm.formData.areas),
      callback: function($$v) {
        _vm.$set(_vm.formData, "areas", $$v)
      },
      expression: "formData.areas"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称",
      "prop": "danwei"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入学校名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "ldname"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.ldname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ldname", $$v)
      },
      expression: "formData.ldname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "num"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系手机",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "已取得艺术导师等级",
      "prop": "grade"
    }
  }, [_c('el-select', {
    staticClass: "inputSizeClass",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }, _vm._l((_vm.gradeOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传照片",
      "prop": "pics"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pics,
      "limit": 5,
      "name": 'pics'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "el-note"
  }, [_vm._v("请上传2张照片（1张艺术照，1张2寸标准照）")])], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人才艺",
      "prop": "caiyi"
    }
  }, [_c('el-input', {
    staticClass: "inputSizeClass",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 4
      },
      "placeholder": "请输入个人才艺"
    },
    model: {
      value: (_vm.formData.caiyi),
      callback: function($$v) {
        _vm.$set(_vm.formData, "caiyi", $$v)
      },
      expression: "formData.caiyi"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-form', {
    ref: "userListForm",
    attrs: {
      "rules": _vm.userListForm.rules,
      "model": _vm.userListForm
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userListForm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.name) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.name',
            "rules": _vm.userListForm.rules.name
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入姓名"
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "身份证",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.num) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.num',
            "rules": _vm.userListForm.rules.num
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入身份证号"
          },
          model: {
            value: (scope.row.num),
            callback: function($$v) {
              _vm.$set(scope.row, "num", $$v)
            },
            expression: "scope.row.num"
          }
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.sex) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.sex',
            "rules": _vm.userListForm.rules.sex
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.sex),
            callback: function($$v) {
              _vm.$set(scope.row, "sex", $$v)
            },
            expression: "scope.row.sex"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "男",
            "value": "男"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "女",
            "value": "女"
          }
        })], 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.phone) + "\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.phone',
            "rules": _vm.userListForm.rules.phone
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入手机号"
          },
          model: {
            value: (scope.row.phone),
            callback: function($$v) {
              _vm.$set(scope.row, "phone", $$v)
            },
            expression: "scope.row.phone"
          }
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "服务套餐"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_vm._v("\n                      " + _vm._s(scope.row.service_name) + " (" + _vm._s(scope.row.service_price) + "元)\n                    ")]) : _c('p', [_c('el-form-item', {
          attrs: {
            "prop": 'list.' + scope.$index + '.service_id',
            "rules": _vm.userListForm.rules.service_id
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              return _vm.onServiceChange($event, scope.row)
            }
          },
          model: {
            value: (scope.row.service_id),
            callback: function($$v) {
              _vm.$set(scope.row, "service_id", $$v)
            },
            expression: "scope.row.service_id"
          }
        }, _vm._l((_vm.service_options), function(service, sindex) {
          return _c('el-option', {
            key: sindex,
            attrs: {
              "label": service.name + '(' + service.price + '元)',
              "value": service.id
            }
          })
        }), 1)], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? _c('p', [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.onUserEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-popconfirm', {
          attrs: {
            "title": "这是一段内容确定删除吗？"
          },
          on: {
            "confirm": function($event) {
              return _vm.onUserRemove(scope.row, scope.$index)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("删除")])], 1)], 1) : _c('p', [_c('el-button', {
          on: {
            "click": function($event) {
              return _vm.onUserSave(scope.row)
            }
          }
        }, [_vm._v("保存")]), _vm._v(" "), _c('el-popconfirm', {
          attrs: {
            "title": "这是一段内容确定删除吗？"
          },
          on: {
            "confirm": function($event) {
              return _vm.onUserRemove(scope.row, scope.$index)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v("删除")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.onUserAdd()
      }
    }
  }, [_vm._v("新增用户")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "btn_position_class"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ensureSubmit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('ElPayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "scene": "rencaiku",
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.centerDialogVisible,
      "width": "50%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("申报信息一旦提交成功后，不可修改！")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("返回修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43e84e77","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/rencaiku/RencaikuApplyStep31.vue
// module id = 1219
// module chunks = 0